import { jsx as _jsx } from "react/jsx-runtime";
import { PromotedBadge } from "@faire/retailer-visitor-shared/features/ADS/PromotedBadge";
import { shouldShowPromotedBadge as getShouldShowPromotedBadge } from "@faire/retailer-visitor-shared/features/ADS/util";
import { TextBadgesClientWrapper } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/TextBadges/__internal__/TextBadgesClientWrapper";
import { textBadgesClientWrapperAdaptor } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/TextBadges/__internal__/textBadgesClientWrapperUtils";
import React from "react";
export var TextBadges = function(param) {
    var data = param.data;
    var shouldShowPromotedBadge = getShouldShowPromotedBadge(data.isPromoted, data.promotedBy);
    return shouldShowPromotedBadge ? /*#__PURE__*/ _jsx(TextBadgesClientWrapper, {
        data: textBadgesClientWrapperAdaptor(data),
        children: /*#__PURE__*/ _jsx(PromotedBadge, {
            noPadding: true
        })
    }) : null;
};
